import React, { useState, useContext, useEffect } from 'react';
import { Helper } from 'utils';
import { Api } from 'services';
import { AppActions } from 'store';
import { StateContext, DispatchContext } from 'context';
import './paquetes.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { withRouter, useLocation } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { Themes } from 'styles';
import { IconButton, TextField } from '@mui/material';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons';

import { SocialShare } from 'components/socialshare';


const Paquetes = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useContext(DispatchContext);
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [paquetesPublicos, setPaquetesPublicos] = useState([]);
    const [paquete, setPaquete] = useState(null);
    const [modalPaquete, setModalPaquete] = useState(false);
   // const [target, setTarget] = useState("");
    const [msgEnvioExitoso, setMsgEnvioExitoso] = useState("");
    // const [modalLista, setModalLista] = useState(false);
    const [imagenes, setImagenes] = useState([]); 
    // const [totalDestinos, setTotalDestinos] = useState(0);
    const location = useLocation();
  
    // Estados para filtros
    const [categorias, setCategorias] = useState([]);
    const [paqueteCategoria, setPaqueteCategoria] = useState(0);
    
    const [data, setData] = useState({
        pe_nombre: "",
        pe_celular: "",
        pe_email: "",
        pe_mensaje: ""
    });
    const [errores, setErrores] = useState({
        pe_nombre: false,
        pe_celular: false,
        pe_email: false,
        pe_mensaje: false
    });
    const [modelo, setModelo] = useState({
        pe_nombre: "",
        pe_celular: "",
        pe_email: "",
        pe_mensaje: ""
    });
    // Nuevo estado para controlar el envío
    const [isSending, setIsSending] = useState(false);

    useEffect(() => {
        getPaquetesPublicos();
        getModelo();
       // getCategorias();
    }, []);

    const getPaquetesPublicos = (idCategoria = '') => {
        setPaqueteCategoria(idCategoria);
       
            // Si es "Todas", mostrar todos los paquetes
           // getCategorias(0); // Actualiza el conteo de todas las categorías
        dispatch(AppActions.setLoading(true));
        dispatch(AppActions.setActionsDisabled(true));
        var options = {
            url: Api.route('/paquetes/paquetes_publicos/' + idCategoria),
            method: 'GET',
           // data: { idpaq_categoria: idCategoria }
        };
        Api.request(options, response => {
            Helper.log('getPaquetesPublicos response', response);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
            if (response.codigo && response.codigo !== 200) {
                enqueueSnackbar(response.mensaje, { variant: 'error' });
            } else {
                if (response.datos) {
                    setPaquetesPublicos(response.datos);
                    // setTotalDestinos(response.datos.length);
                    const nuevaCategorias = categorias.map(cat => {
                            if (cat.idpaq_categoria === idCategoria) {
                                return { ...cat, cant: response.datos.length };
                            }
                            return cat;
                        });
                        setCategorias(nuevaCategorias);
                      //  cantTotalPaquetes();
                        getCategorias(idCategoria); // Actualiza el conteo de todas las categorías
                }
            }
        }, error => {
            Helper.log('error getPaquetesPublicos', error);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
        });
        
    }


    const getCategorias = (idCategoria) => {
        dispatch(AppActions.setActionsDisabled(true));
        var options = {
            url: Api.route('/categoria/listar_total'),
            method: 'GET'
        };
        Api.request(options, response => {
            Helper.log('getCategorias response', response);
            dispatch(AppActions.setActionsDisabled(false));
            if (response.codigo && response.codigo !== 200) {
                enqueueSnackbar(response.mensaje, { variant: 'error' });
            } else {
                if (response.datos) {
                    let total = 0;
                    let todas_total = 0;
                    for (let i in response.datos) {
                        total = total + response.datos[i].cant;
                        todas_total =  response.datos[0].cant_total;
                    }
                    setCategorias([
                        { idpaq_categoria: 0, pc_nombre: 'Todas', cant: total, cant_total: todas_total },
                        ...response.datos
                    ]);
                    setPaqueteCategoria(idCategoria || 0);

                }
            }
        }, error => {
            Helper.log('error getCategorias', error);
            dispatch(AppActions.setActionsDisabled(false));
        });
    }


    const filtrarImagenes = (id) => {
        dispatch(AppActions.setLoading(true));
        dispatch(AppActions.setActionsDisabled(true));
        const options = {
            url: Api.route(`/paquetes_imagen/listar/${id}`),
            method: 'GET'
        };
        Api.request(options, response => {
            Helper.log('filtrarImagenes response', response);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
            if (response.codigo === 200) {
                // Formatea las imágenes para que ImageGallery las pueda usar
                const formattedImages = response.datos.map(img => ({
                    original: Api.route('/imagenes/ver/' + img.idimagen + '/1280/1280'),
                    thumbnail: Api.route('/imagenes/ver/' + img.idimagen + '/200/200')
                })).reverse();
                setImagenes(formattedImages);
            } else {
                enqueueSnackbar(response.mensaje, { variant: 'error' });
            }
        }, error => {
            Helper.log('error filtrarImagenes', error);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
        });
    };

    const abrirModalPaquete = (paq) => {
        setPaquete(paq);
        setModalPaquete(true);
        document.documentElement.style.overflowY = "hidden";
        filtrarImagenes(paq.idpaquete);
    }
    
    const cerrarModalPaquete = () => {
        setModalPaquete(false);
        setImagenes([]);
        document.documentElement.style.overflowY = "inherit";
    }

    const filtrado = (item, targ) => {
        if (!targ || targ === "") {
            return true;
        } else if (targ) {
            if (item.paq_titulo.toLowerCase().search(targ.toLowerCase()) !== -1 || item.paq_contenido.toLowerCase().search(targ.toLowerCase()) !== -1) {
                return true;
            }
        } else {
            return false;
        }
    }

    const getModelo = () => {
        dispatch(AppActions.setLoading(true));
        dispatch(AppActions.setActionsDisabled(true));
        var options = {
            url: Api.route('/paquetes_email/modelo'),
            method: 'GET'
        };
        Api.request(options, response => {
            Helper.log('getModeloEmailAgente response', response);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
            if (response.codigo && response.codigo !== 200) {
                enqueueSnackbar(response.mensaje, { variant: 'error' });
            } else if (response.codigo && response.codigo === 200) {
                setData(response.datos);
                setModelo(response.datos);
            }
        }, error => {
            Helper.log('error getModeloEmailAgente', error);
            dispatch(AppActions.setLoading(false));
            dispatch(AppActions.setActionsDisabled(false));
        });
    }
    const onChangeForm = (event, campo) => {
        setData({
            ...data,
            [campo]: event.target.value
        });
        setErrores({
            ...errores,
            [campo]: false
        });
    }
    const enviarEmailAgente = () => {
        if (isSending) return; // Previene múltiples clics

        const { pe_nombre, pe_celular, pe_email, pe_mensaje } = data;
        let todoBien = true;
        let errors = {
            pe_nombre: false,
            pe_celular: false,
            pe_email: false,
            pe_mensaje: false
        };
        if (pe_nombre && pe_nombre !== "") {
            // datos.pe_nombre = pe_nombre;
        } else {
            todoBien = false;
            errors.pe_nombre = true;
        }
        if (pe_celular && pe_celular !== "") {
            // datos.pe_celular = pe_celular;
        } else {
            todoBien = false;
            errors.pe_celular = true;
        }
        if (pe_email && pe_email !== "" && Helper.validateEmail(pe_email)) {
            // datos.pe_email = pe_email;
        } else {
            todoBien = false;
            errors.pe_email = true;
        }
        if (pe_mensaje && pe_mensaje !== "") {
            // datos.pe_mensaje = pe_mensaje;
        } else {
            todoBien = false;
            errors.pe_mensaje = true;
        }
        console.log('todoBien', todoBien);
        console.log('errores', errors);
        console.log('data', data);
        setErrores(errors);
        if (todoBien) {
            setIsSending(true); // Se establece el estado de envío a true
            dispatch(AppActions.setLoading(true));
            dispatch(AppActions.setActionsDisabled(true));
            const datosParaEnviar = {
                ...data,
                idreferencia: paquete ? paquete.idpaquete : null,
            };
            var options = {
                url: Api.route('/paquetes_email/guardar'),
                method: 'POST',
                data: datosParaEnviar
            };
            Api.request(options, response => {
                Helper.log('enviarEmailAgente response', response);
                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
                setIsSending(false); // Se establece el estado de envío a false
                if (response.codigo && response.codigo !== 200) {
                    enqueueSnackbar(response.mensaje, { variant: 'error' });
                } else if (response.codigo && response.codigo === 200) {
                    setData(modelo);
                    setMsgEnvioExitoso("Hemos recibido tu mensaje, gracias por comunicarte con nosotros");
                    setTimeout(() => {
                        setMsgEnvioExitoso("");
                    }, 6000);
                }
            }, error => {
                Helper.log('error enviarEmailAgente', error);
                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
                setIsSending(false); // Se establece el estado de envío a false
            });
        }
        
    }

    const contar_visitas = (item) => {
                var options = {
                    url: Api.route('/paquetes/contar_visita/' + item.idpaquete),
                    method: 'GET'
                };
                Api.request(options, response => {
                    Helper.log('contar_visitas response', response);
                    if (response.codigo && response.codigo !== 200) {
                        enqueueSnackbar(response.mensaje, { variant: 'error' });
                    } else {
                        if (response.datos) {
                            Helper.log('Visita contabilizada', response.datos);
                        }
                    }
                }, error => {
                    Helper.log('error contar_visitas', error);
                });
            }

        

//   const currentUrl = window.location.href;
    const currentUrl = window.location.origin + location.pathname + 'destino/' + (paquete ? paquete.idpaquete : '');
    const title = "Mira este contenido Destino: " + (paquete ? paquete.paq_titulo : '');


    return (
        <>
            <div id="paquetes" className="w3-block bs-bbox">
                <div className="w3-content-paquetes">
                    <div className="w3-block w3-center">
                        <h1 style={{ color: Themes[indexTema].D4 }}>Destinos</h1>
                    </div>
                    {/* <div className="w3-block w3-center">
                        <div id="search-container">
                            <input id="search-paq" value={target} type="text" onChange={onChangeTarget} placeholder="Busque aquí su paquete..."></input>
                            <button id="ver-mas-button" onClick={() => verMas()} className="ver-mas w3-btn">VER MÁS</button>
                        </div>
                    </div> */}
                    
                    {/* Contenedor principal con sidebar */}
                    <div className="w3-row w3-margin-top">
                        {/* Filtro de categorías fijo al lado izquierdo */}
                        {categorias && categorias.length > 0 ? 
                        <div className="w3-col l2 m3 s12" style={{paddingRight: '15px', boxSizing: 'border-box'}}>
                            <div className="categories-sidebar">
                                <h2 className="categories-title">Categorías</h2>
                                <ul className="categories-list">
                                    {categorias ? categorias.filter(item => item.cant > 0).map((item) => (
                                        <li 
                                           // key={item.idpaq_categoria > 0} 
                                            key={item.idpaq_categoria}
                                            className={`category-item ${paqueteCategoria === item.idpaq_categoria ? 'active' : ''}`}
                                            onClick={() => getPaquetesPublicos(item.idpaq_categoria)}
                                            style={{
                                                    backgroundColor: (paqueteCategoria === item.idpaq_categoria) ? Themes[indexTema].D3 : 'transparent',
                                                }}
                                        >
                                            <span className="category-name">{item.pc_nombre}</span>
                                            {item.pc_nombre === "Todas" ? <span className="category-count">({item.cant_total})</span> : <span className="category-count">({item.cant})</span> }
                                        </li>
                                    )) : null}
                                </ul>
                            </div>
                        </div>
                        : null  }
                        
                        {/* Lista de paquetes al lado derecho */}
                        <div className="w3-col l10 m9 s12" style={{paddingLeft: '15px', boxSizing: 'border-box'}}>
                            
                            <div className="w3-block lista">
                                <div className="w3-row">
                                    {paquetesPublicos ? paquetesPublicos.filter(item => filtrado(item)).map((item) => <div key={item.idpaquete} className="w3-col l3 m6 my-m6 s12 w3-padding bs-bbox">
                                        <div className="grow img-container">
                                            <div className="div-img cursor-pointer" style={{
                                                backgroundImage: 'url('+Api.route('/imagenes_subidas/' + item.ima_nombre)+')', 
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center' ,
                                                backgroundSize: 'cover' 
                                            }}
                                            alt="banner" onClick={() =>{ abrirModalPaquete(item); contar_visitas(item)}} 
                                            ></div>
                                            <div 
                                                className="img-overlay" 
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    abrirModalPaquete(item); 
                                                    contar_visitas(item);
                                                }}
                                            >
                                                <h4>{item.paq_titulo}</h4>
                                                <p>{item.paq_contenido}</p>
                                                <button className="ver-mas w3-btn w3-small">Ver más</button>
                                            </div>
                                                
                                        </div>
                                        {/* <div>
                                            <div className="paq-titulo-container">
                                                <h4>{item.paq_titulo}</h4>
                                            </div>
                                            <p>{item.paq_contenido}</p>
                                            <button onClick={() => {abrirModalPaquete(item); contar_visitas(item) }} className="ver-mas w3-btn w3-small">Ver más</button>
                                        </div> */}
                                    </div>) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {(modalPaquete && paquete) ? <div id="modal-paq" className="w3-modal w3-show ">
                <div className="w3-modal-content w3-animate-zoom w3-round-large " style={{ backgroundColord: 'rgba(0,0,0,0.8)' }}>
                    <div className="w3-row">
                        <div className="w3-col w3-right" style={{ width: '50px' }}>
                            <IconButton aria-label="delete" onClick={() => cerrarModalPaquete()}>
                                &nbsp;<FontAwesomeIcon icon={faTimes} color={'#3A3A3A'} />&nbsp;
                            </IconButton>
                        </div>
                        <div className="w3-rest w3-padding w3-center">
                        </div>
                    </div>
                    <div className="w3-padding">
                        <div className="w3-row">
                            <div className="w3-col l7 col-izquierda"  >
                                {imagenes.length > 1 ? (
                                    <ImageGallery 
                                        items={imagenes} 
                                        showPlayButton={false} 
                                        showFullscreenButton={true} 
                                        thumbnailPosition="bottom"
                                        autoPlay={true}
                                        slideInterval={5000}
                                    />
                                    ) : imagenes.length === 1 ? (
                                            <img className="cursor-pointer w3-block" src={imagenes[0].original} alt="imagen-paquete-principal" />
                                    ) : null}

                            </div>
                             <div className="w3-row titulo-precio  w3-hide-large"   >
                                <div className="w3-col ">
                                    <h2 >{paquete.paq_titulo}</h2>
                                    {/* <span style={{ color: Themes[indexTema].D5 }}>{Helper.formatearNumero(destino.paq_precio)} U$D</span> */}
                                    <p>{paquete.paq_contenido}</p>
                                    <hr />
                                </div>
                             </div>
                            <div className="w3-col l5 col-derecha">
                                <div className="contact-form-container">
                                    <h3 className="w3-color-theme-d4">Contacte con uno de nuestros agentes de viaje</h3>
                                    
                                    <TextField
                                        label="Nombre/Apellido"
                                        id="input-nombre"
                                        size="small"
                                        className="w3-block"
                                        margin="normal"
                                        value={data.pe_nombre}
                                        error={errores.pe_nombre}
                                        onChange={event => onChangeForm(event, 'pe_nombre')}
                                        sx={{
                                            '& .MuiInputLabel-shrink': {
                                                transform: 'translate(26px, -15px) ', // Ajusta este valor
                                                // Asegura que la transformación se origine desde la esquina superior izquierda
                                            },
                                        }}
                                    /><br />
                                    <TextField
                                        label="Celular"
                                        id="input-celular"
                                        size="small"
                                        className="w3-block"
                                        margin="normal"
                                        value={data.pe_celular}
                                        error={errores.pe_celular}
                                        onChange={event => onChangeForm(event, 'pe_celular')}
                                        sx={{
                                            '& .MuiInputLabel-shrink': {
                                                transform: 'translate(20px, -15px)', 
                                            },
                                        }}
                                    /><br />
                                    <TextField
                                        label="Email"
                                        id="input-email"
                                        size="small"
                                        className="w3-block"
                                        margin="normal"
                                        value={data.pe_email}
                                        error={errores.pe_email}
                                        onChange={event => onChangeForm(event, 'pe_email')}
                                        sx={{
                                            '& .MuiInputLabel-shrink': {
                                                transform: 'translate(19px, -15px) ', 
                                            },
                                        }}
                                    /><br />
                                    <TextField
                                        label="Mensaje"
                                        id="input-mensaje"
                                        size="small"
                                        className="w3-block"
                                        margin="normal"
                                        value={data.pe_mensaje}
                                        error={errores.pe_mensaje}
                                        onChange={event => onChangeForm(event, 'pe_mensaje')}
                                        multiline
                                        rows={4}
                                        inputProps={{ maxLength: 450 }}
                                        helperText={`${data.pe_mensaje?.length || 0}/450`}
                                        sx={{
                                            '& .MuiInputLabel-shrink': {
                                                transform: 'translate(18px, -17px) scale(1.1)',
                                            },
                                            '& .MuiFormHelperText-root': {
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                marginRight: 0,
                                            },
                                        }}
                                    />
                                    <br />
                                    <button 
                                        className="w3-btn w3-block w3-light-gray w3-border w3-large w3-round " 
                                        onClick={() => enviarEmailAgente()}
                                        disabled={isSending} // Deshabilita el botón mientras se envía
                                    >
                                        {isSending ? 'Enviando...' : 'Enviar'} {/* Muestra "Enviando..." cuando isSending es true */}
                                    </button>
                                    <a 
                                        className="w3-btn w3-block w3-green w3-large w3-round w3-margin-top" 
                                        style={{padding: '8px 0'}}
                                        href={"https://wa.me/595986229400?text=Hola,%20quiero%20más%20información%20sobre%20el%20destino%20"+paquete.paq_titulo+"%20("+paquete.idpaquete+")"}
                                        
                
                                    >
                                        <FontAwesomeIcon icon={faWhatsapp} aria-hidden="true" title="whatsapp" /> &nbsp;
                                        Contactanos
                                    </a>

                                    {/* <button onClick={copiarEnlace}>
                                        {copied ? '✓ Copiado!' : 'Copiar enlace'}
                                    </button> */}

                                    <div style={{position:'relative', height:80}}><SocialShare url={currentUrl} title={title} position='absolute'/></div>
                                   
                                    {msgEnvioExitoso ? <p className="w3-text-black">{msgEnvioExitoso}</p> : null}
                                </div>
                            </div>
                        </div>
                        {/* Movido la información del paquete después del formulario, dentro de un contenedor separado */}
                    
                         <div className="w3-row titulo-precio w3-hide-small w3-hide-medium"   >
                            <div className="w3-col ">
                                <h2 >{paquete.paq_titulo}</h2>
                                {/* <span style={{ color: Themes[indexTema].D5 }}>{Helper.formatearNumero(paquete.paq_precio)} U$D</span> */}
                                <p>{paquete.paq_contenido}</p>
                                <hr />
                            </div>
                        </div>
                        <div className="w3-right-align">
                            <button className="w3-btn w3-light-gray w3-large w3-round w3-margin-bottom"  onClick={() => cerrarModalPaquete()} disabled={isSending}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div> : null}
            {/* {(modalLista) ? <div id="modal-lista" className="w3-modal w3-show" style={{ paddingTop: '40px'  }}>
                <div className="w3-modal-content w3-animate-zoom w3-round-large">
                    <div className="w3-row">
                        <div className="w3-col w3-right" style={{ width: '50px' }}>
                            <IconButton aria-label="delete" onClick={() => cerrarModalLista()}>
                                &nbsp;<FontAwesomeIcon icon={faTimes} color={'#3A3A3A'} />&nbsp;
                            </IconButton>
                        </div>
                        <div className="w3-rest w3-padding w3-center">
                        </div>
                    </div>
                    <ListaPaquetes abrirModalPaquete={abrirModalPaquete} />
                </div>
            </div> : null} */}
        </>
    );
}

export default withRouter(Paquetes);